/* eslint-disable import/no-default-export */
import classNames from 'classnames';
import Icon, { IconColor, IconName } from 'app/common/components/controls/icon';
import React from 'react';
import styles from './BoardButton.less';

interface OwnProps {
  className: string;
  icon?: IconName;
  iconColor?: IconColor;
  iconLarge?: boolean;
  onClick: React.EventHandler<React.MouseEvent<HTMLButtonElement>>;
  tabIndex?: number;
  title: string;
}

function onFocusChange(e: React.FocusEvent) {
  e.stopPropagation();
}

export const BoardButton: React.FunctionComponent<OwnProps> = ({
  children,
  className,
  icon,
  iconColor,
  iconLarge,
  onClick,
  tabIndex,
  title,
}) => (
  <button
    className={classNames(styles.button, className)}
    onFocus={onFocusChange}
    onBlur={onFocusChange}
    onClick={onClick}
    tabIndex={tabIndex}
    title={title}
  >
    {icon && (
      <Icon
        color={iconColor}
        name={icon}
        large={iconLarge}
        small={!iconLarge}
        className={children && icon ? styles.iconWithPadding : ''}
      />
    )}
    {children}
  </button>
);
